import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import Flex from "../../Generic/Flex";

interface Props {
  selectedDateTime: LocalDateTime | null;
  onClickApprove: () => void;
}

const AvailableTaskFooter = (props: Props) => {
  const dateStr =
    props.selectedDateTime === null
      ? null
      : globalize().formatLocalDateTime(props.selectedDateTime, { datetime: "short" });

  return (
    <Flex direction="column" className="AvailableTaskFooter">
      <AppButton onClick={props.onClickApprove}>
        {dateStr === null
          ? translate(STRINGS.TAKE_THIS_TASK)
          : translate(STRINGS.SCHEDULE_FOR).replace("{{date}}", dateStr)}
      </AppButton>
    </Flex>
  );
};

export default AvailableTaskFooter;
